<template>

<div>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />
    </div>

  <div class="px-4">
    

    <div class="relative py-16 bg-white overflow-hidden">
      <div class="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
        <div
          class="relative h-full text-lg max-w-prose mx-auto"
          aria-hidden="true"
        >
          <svg
            class="absolute top-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
            />
          </svg>
          <svg
            class="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
            />
          </svg>
          <svg
            class="absolute bottom-12 left-full transform translate-x-32"
            width="404"
            height="384"
            fill="none"
            viewBox="0 0 404 384"
          >
            <defs>
              <pattern
                id="d3eb07ae-5182-43e6-857d-35c643af9034"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="384"
              fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
            />
          </svg>
        </div>
      </div>
      <div class="relative px-4 sm:px-6 lg:px-8">
        <!--
        <div class="text-lg max-w-prose mx-auto">
          <h1>
            <span
              class="block text-base text-center text-indigo-600 font-semibold tracking-wide uppercase"
              >Article</span
            >
            <span
              class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
              >{{ title }}</span
            >
          </h1>
        </div>
        -->
        <div class="max-w-prose mx-auto mt-12 mb-8">
          <figure>
            <img
              src="/images/about.png"
              class="w-full rounded-lg"
              width="1310"
              height="873"
              alt=""
            />


          </figure>
        </div>
        <div class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
<p>
От обучения на всю жизнь – к обучению через всю жизнь: эти слова полностью соответствуют задачам, которые ставятся последипломным медицинским образованием. Созданный нами образовательный портал реализован в формате бесплатного массового открытого образовательного онлайн ресурса, посвященного доказательной медицине.
</p>
<p>
В медицине быстро меняются стандарты, появляются новые методы диагностики и лечения, внедряются инновационные лекарственные препараты. Современная медицина – это новые знания, внедренные в практическую деятельность на всех уровнях медицинской помощи. Врач не может просто отучиться, получить диплом и спокойно работать. Врачи ежедневно соревнуются с болезнью, должны играть на опережение, знать самые современные методы и протоколы, учиться и развиваться.
</p>
<p>
Фонд поддержки и развития доказательной медицины при поддержке Фонда Президентских Грантов организовал образовательную платформу для врачей, медицинских сестер и пациентов.
</p>
<p>
Основной контент, который размещается на данном ресурсе – это дистанционные программы повышения квалификации врачей и медицинских сестер. Дистанционный формат обучения позволит врачам и медицинским сестрам без отрыва от работы повышать свой уровень квалификации вне зависимости от региона проживания. В разработке программ участвовали практикующие врачи, имеющие ученые степени и звания, а также многолетний опыт работы и участия в клинических исследованиях.
</p>
<p>
    Каждая размещаемая на портале программа будет включать в себя:
    <ul>

        <li>-тематические модули в формате видео-лекций, основной акцент которых – разбор клинических случаев из реальной медицинской практики;</li>
        <li>-вебинар с разработчиками программы;</li>
        <li>-онлайн общение с лекторами;</li>
        <li>-входное тестирование перед каждой лекцией;</li>
        <li>-тестирование по итогам прохождения каждого модуля, а также итоговое тестирование.</li>
    </ul>
</p>

<p>
Помимо образовательных программ на регулярной основе на портале размещаются результаты исследований, клинические разборы, интервью с ведущими специалистами, международные и российские новости. Посетители образовательной платформы могут получить концентрированную информацию в соответствии со своей специализацией и кругом профессиональных интересов. 
</p>
<p>
Однако, данный ресурс актуален не только для врачей, но и для обычных пациентов. Если вы один из них, на нашем сайте специально для Вас есть раздел с комментариями врачей, памятками и записями мастер классов (например, проведение инъекций и замеров, советы по подготовке к лечению онкологии и прохождению реабилитации после его завершения). Мы уверены, что информирование пациентов в конечном итоге повышает эффективность терапии за счет большей к ней приверженности. В контексте сложившейся эпидемиологической ситуации с распространением вируса COVID-19 наша задача – максимально облегчить жизнь врачей, сделать ее комфортнее, а образование для них доступнее.
</p>

     </div>
      </div>
    </div>

  </div>
</div>
</template>






<script>
import PageTitle from "@/components/PageTitle";
export default {
    data() {
        return {
            title: 'О проекте'
        }
    },
    components: {
        PageTitle,
    }
}
</script>